/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import {
  ITechnicalExpertiseData,
  ITechnicalExpertiseDataState,
  ITechnicalExpertiseOptionList,
} from "../../Interfaces/SiteContent";

/**
 * Technical Expertise data selector.
 */
export const getTechnicalExpertise = (
  state: ITechnicalExpertiseDataState
): ITechnicalExpertiseData[] => state.technicalExpertise;

/**
 * Technical Expertise option list data selector.
 */
export const getTechnicalExpertiseOptionList = (
  state: ITechnicalExpertiseDataState
): ITechnicalExpertiseOptionList[] => state.technicalExpertiseOptionList;

/**
 * Technical Expertise data load error selector.
 */
export const getTechnicalExpertiseLoadError = (state: ITechnicalExpertiseDataState): string =>
  state.technicalExpertiseLoadError;
